<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.5 6.25V18.75M9.375 15.8144L10.2905 16.501C11.5108 17.4163 13.4894 17.4163 14.7097 16.501C15.9301 15.5857 15.9301 14.1018 14.7097 13.1865C14.0995 12.7288 13.2997 12.5 12.4999 12.5C11.7447 12.5 10.9898 12.2712 10.4136 11.8136C9.26146 10.8983 9.26146 9.41429 10.4136 8.499C11.5658 7.58371 13.4339 7.58371 14.5861 8.499L15.0183 8.84232M21.875 12.5C21.875 17.6777 17.6777 21.875 12.5 21.875C7.32233 21.875 3.125 17.6777 3.125 12.5C3.125 7.32233 7.32233 3.125 12.5 3.125C17.6777 3.125 21.875 7.32233 21.875 12.5Z"
				:stroke="color"
				stroke-width="1.5625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgDollar',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
